import DxmlPage from "../DxmlPage";
import * as Constants from "../../../../../utils/constants"
import { WebEditorContext } from "../../../../../contexts";
import { useContext } from "react";
import { useEditorFile } from "../../../../../hooks/useEditorFile";

export default function DxmlDocument() {
    const { editorFileRef } = useContext(WebEditorContext);
    const editorPages = editorFileRef.current?.Doc?.Items?.filter(item => item.Type === Constants.editorType.page);
    const { getChildItemsToShow, getKeyById } = useEditorFile();

    return (
        <>
            {editorPages && editorPages.map((editorPage, index) => (
                <div key={getKeyById(editorPage)}>
                    <DxmlPage 
                        editorPage={editorPage}
                        isLastPage={(index + 1) === editorPages.length}
                    />
                </div>
            ))}
        </>
    )
}